/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useRef, useEffect, useCallback } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import ProductIcon from "../../../../../assets/images/icon_menus/ProductIcon.json";
import clsx from 'clsx';
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { checkComponentPermission, checkCRUDPermission, checkViewPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { TextField } from "@mui/material";
import usePrevious from "../../../../Shared/components/Previous";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Link, NavLink } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { ListTable } from "./ListTable";
import crudActions from "../../../../CRUD/redux/actions";
import { useEventListener } from "../../../../../helpers/useEventListener";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";


export default function StockCount(props) {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);

    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const limit = 25;
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const { history } = props;
    const dispatch = useDispatch();

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Stock Count', history, 'Product')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }


    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
    });


    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ countStatus: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'stockCount',
            skip: skip,
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const handleKeyDown = (e) => {
        if ((e.altKey && e.keyCode === 78) || (navigator.platform.match("Mac") && e.ctrlKey && e.keyCode === 78)) {
            e.preventDefault();
            // history.push('/sales/sales-management/sales-quote/create');
        }
    };

    useEventListener("keydown", handleKeyDown);

    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'} img={ProductIcon}
                closeLink={'/product'}
                title={'Product'} links={[{ 'label': 'Product', 'link': '/Product' }, { 'label': 'Stock Count', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Stock Count'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Stock Count', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Transaction Number & Status'
                                                type='search'
                                                value={search}
                                                id={idNamingConversion('Search', 'stockCount', 'TextField')}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24}
                                    className={clsx(classes.textAlignRight, classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Stock Count', 'create', 'Product') &&
                                                <Link
                                                    to={"/product/inventory/stock-count/create"}
                                                    id={idNamingConversion('Create Stock Count', 'stockCount', 'Link')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Create Stock Count</span>
                                                </Link>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                loadTasks={() => loadTasks()}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortBy={sortBy} sortOrder={sortOrder}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
        </Fragment>
    )
}